module.exports = __webpack_public_path__ + "static/media/keanu-villagonzalo.9d9a1a0c.png";